import React from 'react';
import { PlusIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useStore } from '../../lib/store';
interface NowCompactProduct {
  id: number;
  name: string;
  brand?: string;
  price: number;
  originalPrice?: number;
  discount?: number;
  image: string;
}
interface NowCompactProductCardProps {
  product: NowCompactProduct;
}
export function NowCompactProductCard({
  product
}: NowCompactProductCardProps) {
  const navigate = useNavigate();
  const addToCart = useStore(state => state.addToCart);
  const calculatedDiscount = product.discount ?? (product.originalPrice ? Math.round((product.originalPrice - product.price) / product.originalPrice * 100) : undefined);
  const addProduct = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    addToCart({
      id: product.id,
      name: product.name,
      price: product.price,
      image: product.image,
      brand: product.brand
    });
  };
  return <article role="button" tabIndex={0} onClick={() => navigate(`/product/${product.id}`)} onKeyDown={event => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      navigate(`/product/${product.id}`);
    }
  }} className="group min-w-0 cursor-pointer rounded-lg bg-white p-1.5 focus:outline-none focus:ring-2 focus:ring-[#103d91] focus:ring-offset-2" data-id="element-4503" data-mp="2bo7zlaq0mx29">
      <div className="relative aspect-square overflow-hidden rounded-md bg-[#f7f8fb]" data-id="element-4504" data-mp="2ulsouiwozxne">
        <img src={product.image} alt={product.name} className="h-full w-full object-cover transition-transform duration-200 group-hover:scale-[1.03]" loading="lazy" data-id="element-4505" data-mp="2pp29jxspp631" />
        {calculatedDiscount && <span className="absolute left-1.5 top-1.5 rounded bg-[#ef3d68] px-1.5 py-0.5 text-[9px] font-bold text-white" data-id="element-4506" data-mp="2gm9hvtfmasco">Save {calculatedDiscount}%</span>}
        <button type="button" onClick={addProduct} className="absolute bottom-1.5 right-1.5 flex h-7 w-7 items-center justify-center rounded-md bg-white text-[#183f88] shadow-[0_1px_4px_rgba(30,43,85,0.16)] transition-[background-color,transform] duration-150 active:scale-95" aria-label={`Add ${product.name} to cart`} data-id="element-4507" data-mp="158feod1wffed">
          <PlusIcon className="h-4 w-4" strokeWidth={2.4} data-id="element-4508" data-mp="xqpjm4vhnhog" />
        </button>
      </div>
      <div className="px-0.5 pb-1 pt-2" data-id="element-4509" data-mp="11oexvlcp58ja">
        <h3 className="line-clamp-2 min-h-[32px] text-xs font-medium leading-4 text-gray-800" data-id="element-4510" data-mp="nz3bwiid00qg">{product.name}</h3>
        <div className="mt-1 flex flex-wrap items-baseline gap-x-1" data-id="element-4511" data-mp="sq1slj79f0u8">
          <span className="text-sm font-bold text-[#e6325c]" data-id="element-4512" data-mp="e0nlkhr5ovi0">SAR {product.price.toFixed(2)}</span>
          {product.originalPrice && <span className="text-[10px] text-gray-400 line-through" data-id="element-4513" data-mp="iz7a8px4wle2">{product.originalPrice.toFixed(2)}</span>}
        </div>
      </div>
    </article>;
}